__turbopack_context__.v({
  "button": "tour-card-module-scss-module__VqL7Fa__button",
  "buttonBack": "tour-card-module-scss-module__VqL7Fa__buttonBack",
  "buttonNext": "tour-card-module-scss-module__VqL7Fa__buttonNext",
  "closeButton": "tour-card-module-scss-module__VqL7Fa__closeButton",
  "content": "tour-card-module-scss-module__VqL7Fa__content",
  "contentText": "tour-card-module-scss-module__VqL7Fa__contentText",
  "controls": "tour-card-module-scss-module__VqL7Fa__controls",
  "iconContainer": "tour-card-module-scss-module__VqL7Fa__iconContainer",
  "iconText": "tour-card-module-scss-module__VqL7Fa__iconText",
  "skipLink": "tour-card-module-scss-module__VqL7Fa__skipLink",
  "stepDot": "tour-card-module-scss-module__VqL7Fa__stepDot",
  "stepDotActive": "tour-card-module-scss-module__VqL7Fa__stepDotActive",
  "stepIndicator": "tour-card-module-scss-module__VqL7Fa__stepIndicator",
  "title": "tour-card-module-scss-module__VqL7Fa__title",
  "tourCard": "tour-card-module-scss-module__VqL7Fa__tourCard",
});
